<template>
    <ul class="sidebar-container" v-loading="isLoading">
        <h1 class="blogtype">文章分类</h1>
        <li v-for="item in getList" :key="item.id">
            <div class="category-content" @click="handleClick(item)">
                <span :class="{ active: item.isSelected }">{{ item.item.name }}</span>
                <span :class="{ active: item.isSelected }" class="item-count">{{ item.item.articleCount }}篇</span>
            </div>
        </li>
    </ul>
</template>

<script>
import { getBlogsType } from '@/api/banner'
export default {
    name: "Sidebar",
    data() {
        return {
            list: [],
            isLoading: true
        }
    },
    computed: {
        routeInfo() {
            const categoryId = +this.$route.params.categoryId || -1;
            const page = +this.$route.query.page || 1;
            const limit = +this.$route.query.limit || 10;
            return {
                categoryId,
                page,
                limit
            }
        },
        getList() {
            var totalCount = 0;
            for (var i = 0; i < this.list.length; i++) {
                totalCount += this.list[i].articleCount
            }
            const tempList = [
                { name: '全部', id: -1, articleCount: totalCount, order: 0 },
                ...this.list
            ]
            const newList = tempList.map(item => ({
                item,
                isSelected: item.id === +this.routeInfo.categoryId
            }))
            return newList
        }
    },
    created() {
        getBlogsType().then(r => {
            this.list = r.data.data
            this.isLoading = false
        })
    },
    methods: {
        handleClick(item) {
            if (item.isSelected) {
                return
            }
            //全部分类跳转
            if (item.item.id === -1) {
                this.$router.push({
                    name: "Blog",
                    query: {
                        page: 1,
                        limit: this.routeInfo.limit
                    }
                })
            }
            else { //分类页面下跳转
                this.$router.push({
                    name: "BlogCategory",
                    query: {
                        page: 1,
                        limit: this.routeInfo.limit
                    },
                    params: {
                        categoryId: item.item.id
                    }
                })
            }

        }
    }
}
</script>

<style lang="less" scoped>
.sidebar-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    padding-left: 25px;

    .activetotal {
        color: rgb(255, 0, 0)
    }

    .total-count {
        .count {
            margin-left: 15px;
        }

    }

    ul,
    li {
        list-style: none;
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin-left: 0px;
    }

    li {
        min-height: 40px;
        line-height: 40px;
    }

    .active {
        color: rgb(255, 0, 0)
    }
}

.item-count {
    padding-left: 15px;
    color: #666;
    font-size: 12px;
}
</style>